'use strict';

var React = require('react');
var PropTypes = React.PropTypes;

function ModalFooter(props) {
  var className = 'cf-modal__footer';

  if (props.simple) {
    className += ' cf-modal__footer--simple';
  }

  return React.createElement(
    'div',
    { className: className },
    props.children
  );
}

ModalFooter.propTypes = {
  simple: PropTypes.bool
};
ModalFooter.defaultProps = {
  simple: false
};

module.exports = ModalFooter;